var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content__wrapper"},[_c('Spinner',{attrs:{"isOpen":_vm.isLoading}}),_c('div',{staticClass:"map__wrapper"},[_c('WorldMap2D',{staticClass:"2d-world-map"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }